import { createFileRoute, redirect, useLocation } from '@tanstack/react-router'
import { ContractTemplateEditorPage, contractTemplateSearchSchema } from '@/features/contract/index.ts'

export const Route = createFileRoute('/_authenticated/contracts/templates/versions/$versionId')({
  beforeLoad: ({ params }) => {
    const versionId = Number(params.versionId)
    if (!Number.isInteger(versionId) || versionId <= 0) {
      throw redirect({ to: '/contracts/templates', replace: true, search: { current: 1, pageSize: 20 } })
    }
  },
  component: ContractTemplateVersionRoutePage,
  head: () => ({ meta: [{ title: '合同模板版本 · Super Mega' }] })
})

function ContractTemplateVersionRoutePage() {
  const { currentSession } = Route.useRouteContext()
  const { versionId } = Route.useParams()
  const savedSearch = useLocation({ select: (location) => location.state.contractTemplateReturnSearch })
  const search = contractTemplateSearchSchema.parse(savedSearch ?? {})
  const canManage =
    currentSession.isSuperAdmin ||
    currentSession.permissions.some(
      (permission) => permission.startsWith('contract.template.') && !permission.endsWith('.read')
    )

  return (
    <ContractTemplateEditorPage canManage={canManage} readOnly returnSearch={search} versionId={Number(versionId)} />
  )
}
